module.exports = __webpack_public_path__ + "img/pay-icon-6.3f7b1963.png";